import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LegendItem } from "./LegendItem";

export interface IClauseChecklistData {
    id: number;
    value: number;
    label: string;
    color: string;
}

interface IProps {
    data: IClauseChecklistData[];
}

export const ClauseChecklistsLegend = ({ data }: IProps) => {
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down("lg"));
    const mobile = useMediaQuery(theme.breakpoints.down("sm"));

    const sortedData = data.sort((a, b) => b.value - a.value);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                ml: 2,
                maxWidth: 400,
                width: "100%",
                height: "100%",
                overflow: "hidden",
            }}
        >
            <Typography
                variant={mobile ? "subtitle1" : responsive ? "h6" : "h5"}
                mb={3}
                noWrap
                fontSize={mobile ? 18 : responsive ? 24 : 20}
            >
                Clause Checklists
            </Typography>
            <Stack spacing={2}>
                {sortedData.map((item) => (
                    <LegendItem key={item.id} item={item} />
                ))}
            </Stack>
        </Box>
    );
};
